import { getDetailRecom } from '@/api/recom/index';
import initialize from './recommandationInitialize';

export default async function getRecommandation(id) {
  const response = await getDetailRecom(id);
  initialize(response.data.opportunite);
  return response.data;
}
